import { FC, SVGProps } from 'react';

const WabaQualityRatingHigh: FC<
  SVGProps<SVGSVGElement> & { size?: number }
> = ({ size = '24px', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      {...props}
    >
      <path
        fill="#2C8E47"
        d="M9.86.167c.553 0 1 .446 1 1v8.666c0 .554-.447 1-1 1-.553 0-1-.446-1-1V1.167c0-.554.447-1 1-1Zm-8 6.666c.553 0 1 .447 1 1v2c0 .554-.447 1-1 1-.553 0-1-.446-1-1v-2c0-.553.447-1 1-1Zm4-3.333c.553 0 1 .447 1 1v5.333c0 .554-.447 1-1 1-.553 0-1-.446-1-1V4.5c0-.553.447-1 1-1Z"
      />
    </svg>
  );
};

export default WabaQualityRatingHigh;
